import React from 'react'
import { Grid, Card, CardContent } from '@mui/material'
import SideBar from '../../components/admin/SideBar'

const DashboardAdmin = () => {
  return (
    <Grid container justifyContent='space-around'>
      <Grid item xs={2}><Card>
        <CardContent>
          <Grid container justifyContent='center' alignItems='center' direction='column'>
            <Grid item>
              <SideBar />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      </Grid>

      <Grid item xs={9}>
        This is something else
      </Grid>
    </Grid>
  );
}

export default DashboardAdmin
